const initialState = {
    data: [],
    chartData: {},
    pieChartData: {},
    fundmanagerChartData: {},
    orgChartData: {},
    piechartOptions: {},
    orgChart: {},
    orgTableData:[],
  };
  
  const OrgDashboardReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
      case 'FETCH_CHART_DATA_SUCCESS':
        return {...state,chartData: action.payload.chartData,chartOptions: action.payload.chartOptions};
      case 'FETCH_PIE_CHART_DATA_SUCCESS':
        return {...state,pieChartData: action.payload.pieChartData,piechartOptions: action.payload.piechartOptions};
        case 'FETCH_ORGANISATION_CHART_DATA_SUCCESS':
            return {...state,orgChartData: action.payload.orgChartData,orgChart: action.payload.orgchartOptions};
        case 'FETCH_Org_Table_CHART_DATA_SUCCESS':
            return { ...state, orgTableData: action.payload.orgTableData };
      default:
        return state;
    }
  };
  
  export default OrgDashboardReducer;
  
  